var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[_vm.$style.container, _vm.$style[this.context]]},_vm._l((_vm.countries),function(country,index){return _c('li',{key:(index + "-" + (country.flag))},[(_vm.elementLinks(country).length > 1)?_c('a',{directives:[{name:"tippy",rawName:"v-tippy",value:({
        theme: 'wika light tooltip',
        interactive: true,
        reactive: true,
        placement: 'top',
        flip: false,
        animation: 'fade',
        duration: [200, 600],
        animateFill: false,
        arrow: true,
        zIndex: 10002,
        html: '#countrydownloadLinks-' + index,
        trigger: _vm.isMobileDevice ? 'click' : 'mouseenter focus'
      }),expression:"{\n        theme: 'wika light tooltip',\n        interactive: true,\n        reactive: true,\n        placement: 'top',\n        flip: false,\n        animation: 'fade',\n        duration: [200, 600],\n        animateFill: false,\n        arrow: true,\n        zIndex: 10002,\n        html: '#countrydownloadLinks-' + index,\n        trigger: isMobileDevice ? 'click' : 'mouseenter focus'\n      }"}],ref:"tippy",refInFor:true,class:_vm.$style.flagContainer,attrs:{"href":country.url || '#',"target":"_blank"},on:{"init":_vm.initTippy,"show":_vm.forceRerender}},[_c('Flag',{class:_vm.$style.flag,attrs:{"flag":country.flag,"title":country.language}})],1):_c('a',{class:_vm.$style.flagContainer,attrs:{"href":country.url || '#',"target":"_blank"}},[_c('Flag',{class:_vm.$style.flag,attrs:{"flag":country.flag,"title":country.language}})],1),(_vm.elementLinks(country).length > 1 && !_vm.hideTooltip)?_c('ul',{class:_vm.$style.downloadLinks,attrs:{"id":'countrydownloadLinks-' + index}},[(country.url && _vm.hasWishlistLink())?_c('li',[_c('WishListLink',{key:("key-" + _vm.componentKey),attrs:{"config":{
            text: _vm.labels.wishlist,
            item: {
              types: _vm.types,
              section: _vm.section,
              title: _vm.title,
              subTitle: _vm.subTitle,
              downloads: _vm.groupedDownloadsByUrl[country.url]
            }
          }}})],1):_vm._e(),(country.ebook)?_c('li',[_c('a',{attrs:{"href":country.ebook,"target":"_blank"},on:{"click":function($event){_vm.wtParams &&
              _vm.wtTrack(
                { cat: 'E_BOOK' },
                Object.assign({}, _vm.wtParams,
                  {doctype: 'E_BOOK',
                  description:
                    country.wtParams && country.wtParams.description
                      ? country.wtParams.description
                      : _vm.wtParams.description || country.title || _vm.title,
                  filename: country.ebook})
              )}}},[_c('i',{staticClass:"fas fa-book"}),_vm._v(_vm._s(_vm.labels.ebook)+"\n        ")])]):_vm._e(),(country.url)?_c('li',[_c('a',{attrs:{"href":country.url,"target":"_blank"},on:{"click":function($event){_vm.wtParams &&
              _vm.wtTrack(
                { cat: _vm.wtParams.doctype },
                Object.assign({}, _vm.wtParams,
                  {description:
                    country.wtParams && country.wtParams.description
                      ? country.wtParams.description
                      : _vm.wtParams.description || country.title || _vm.title,
                  filename: country.url})
              )}}},[_c('i',{staticClass:"fas fa-file-pdf"}),_vm._v(_vm._s(_vm.labels.pdf)+"\n        ")])]):_vm._e()]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }